const fileObj = file => {
  if (!file) return null;

  const { lastModified, lastModifiedDate, name, size, type } = file;
  return { lastModified, lastModifiedDate, name, size, type };
};

const getDefaultState = () => {
  return {
    _id: null,
    key: null,

    // Stage1
    fio: null,
    email: null,
    bdate: null,
    videobc: null,
    paths: [{ _no: 1, institute: null, type: null }],

    // Stage2
    organization: null,
    grade: null,
    grade_scan: null,
    app_scan: null,

    // Stage3
    papers: [],

    // Stage4
    achs_base: [],

    // Stage5
    achs_spec: [],
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    fieldUpdate(state, value) {
      state[value.name] = value.value;
    },
    fileUpdate(state, value) {
      state[value.name] = fileObj(value.value);
    },
    arrayAdd(state, value) {
      const array = state[value.name];
      let no = 1;
      if (array.length) no += array[array.length - 1]._no;

      state[value.name].push({ _no: no, ...value.value });
    },
    arrayRemove(state, value) {
      state[value.name].splice(value.value, 1);
    },
    arrayUpdate(state, value) {
      state[value.name][value.no][value.field] = value.value;
    },
    arrayFileUpdate(state, value) {
      state[value.name][value.no][value.field] = fileObj(value.value);
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    updateState(state, value) {
      Object.assign(state, value);
    },
  },

  getters: {
    /**
     * Get values for saving in localStorage
     */
    savingValues: state => {
      return state;
    },
  },
};
